<template>
  <a
    v-if="showRejectFlg"
    style="color: #ff4d4f"
    href="javascript:void(0);"
    size="small"
    type="link"
    :loading="loading"
    :class="className"
    danger
    @click="showDialog"
  >
    拒绝
  </a>

  <a-modal :confirmLoading="loading" v-model:visible="visible" title="添加审批意见" @ok="handleOk">
    <div class="approval-dialog__subtitle">当前操作：拒绝</div>
    <a-textarea
      show-count
      v-model:value="approvalContent"
      placeholder="请输入审批意见，最多200字"
      :auto-size="{ minRows: 3 }"
      :maxlength="200"
      allowClear
    />
  </a-modal>
</template>

<script>
import { defineComponent, reactive, toRefs, computed } from "vue";
import { ApprovalFlowService } from "../approval-flow.service";
import { message } from "ant-design-vue";
import { useStore } from "@/store";
export default defineComponent({
  name: "submit-approval-btn",
  props: {
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    flg: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
    access: {
      type: String,
    },
    className: {
      type: String,
    },
  },
  emits: ["refresh", "update:loading"],
  setup(props, { emit }) {
    const store = useStore();
    const state = reactive({
      visible: false,
      approvalContent: "",
    });
    const showDialog = () => {
      state.approvalContent = "";
      state.visible = true;
    };
    const { run } = ApprovalFlowService.useRejectApi();
    const handleOk = async () => {
      try {
        emit("update:loading", true);
        const { bizId, bizType } = props;
        const data = {
          bizId,
          bizType,
          remark: state.approvalContent,
        };
        let res = await run(data);
        if (res.respCode !== "0000") {
          // message.error(res.respDesc);
          return;
        }
        message.success(res.respDesc);
        emit("refresh", null);
        state.visible = false;
      } finally {
        emit("update:loading", false);
      }
    };
    const showRejectFlg = computed(() => {
      let t = store.state.user.buttons[props.access || ""];
      return t && props.flg;
    });
    return {
      ...toRefs(state),
      showDialog,
      handleOk,
      showRejectFlg,
    };
  },
});
</script>

<style scoped>
.approval-dialog__subtitle {
  color: #6d6d6d;
  position: absolute;
  top: 16px;
  left: 128px;
  font-size: 14px;
}
</style>
